import { toast } from "sonner";
import { blankCharge } from "./ChargeRows";

const addCharge = (f, charge_type, description) => ({ charges: [...f.charges, { ...blankCharge(), charge_type, description }] });
const withReason = (f, text) => (f.reason.trim() ? {} : { reason: text });

// Presets only pre-fill the form; every amount is still shown in the preview before anything is saved.
export const PRESETS = [
  { key: "late_return", label: "Late Return", apply: (f) => ({ ...withReason(f, "Late return"), collectionStatus: "returned_late", ...addCharge(f, "late_fee", "Late return") }) },
  { key: "rental_extension", label: "Rental Extension", apply: (f, s) => ({ ...withReason(f, "Rental extension"), newDays: f.newDays || String((s.final_days || 0) + 1), rentMode: f.rentMode || "external_pending" }) },
  { key: "minor_repair", label: "Minor Repair", apply: (f) => ({ ...withReason(f, "Minor repair"), ...addCharge(f, "damage", "Minor repair") }) },
  { key: "damage", label: "Damage", apply: (f) => ({ ...withReason(f, "Damage"), ...addCharge(f, "damage", "Damage") }) },
  { key: "cleaning", label: "Cleaning", apply: (f) => ({ ...withReason(f, "Cleaning required"), ...addCharge(f, "cleaning", "Cleaning") }) },
  { key: "missing_item", label: "Missing Item", apply: (f) => ({ ...withReason(f, "Missing item"), ...addCharge(f, "missing", "Missing item") }) },
  { key: "not_collected", label: "Item Not Collected", apply: (f, s) => ({ ...withReason(f, "Item not collected"), collectionStatus: "not_collected", newRent: "0", credit: String(s.rent_paid_original || s.final_rent || ""), bondAction: "full_refund" }) },
  { key: "bond_refund", label: "Bond Refund", apply: (f) => ({ ...withReason(f, "Bond refund"), bondAction: "full_refund" }) },
  { key: "rental_credit", label: "Rental Credit", apply: (f, s) => {
    const due = Math.max(-(s.rent_balance || 0), 0);
    if (!f.credit && !due) toast.info("No rent is due back on this item — enter the credit amount yourself");
    return { ...withReason(f, "Rental credit"), credit: f.credit || (due ? String(due) : "") };
  } },
];

export function PresetBar({ f, set, summary, testid = "preset" }) {
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={`${testid}-bar`}>
      {PRESETS.map((p) => (
        <button key={p.key} type="button" onClick={() => set(p.apply(f, summary))}
          className="px-2.5 py-1 text-[10px] uppercase tracking-wider border border-[#9A7B4F]/30 text-[#9A7B4F] hover:bg-[#9A7B4F] hover:text-white transition-colors"
          data-testid={`${testid}-${p.key}`}>
          {p.label}
        </button>
      ))}
    </div>
  );
}
